import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

import { AuthCodeFlowConfig, LAST_ROUTE } from '../auth.config';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _hasValidToken = new ReplaySubject<boolean>(1);
  hasValidToken = this._hasValidToken.asObservable();

  constructor(private oauthService: OAuthService, private router: Router) {}

  async tryToLogin() {
    this.oauthService.configure(AuthCodeFlowConfig);
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();

    if (!this.oauthService.hasValidAccessToken()) {
      this._hasValidToken.next(false);
      this.oauthService.initCodeFlow();
      return;
    }

    await this.oauthService.loadUserProfile();

    this.oauthService.setupAutomaticSilentRefresh();
    this._hasValidToken.next(true);

    const url = localStorage.getItem(LAST_ROUTE) as string;
    localStorage.removeItem(LAST_ROUTE);

    if (!url || url == '/') {
      this.router.navigate(['']);
      return;
    }

    this.router.navigateByUrl(url);
  }

  public get accessToken() {
    return this.oauthService.getAccessToken();
  }

  public get userInfo(): User {
    return this.oauthService.getIdentityClaims() as User;
  }

  public logout() {
    this.oauthService.logOut();
  }
}
